<div class="blog-details">
  <!-- 🔥 NOUVEAU : Loader principal -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="container">
      <div class="loading-content">
        <div class="spinner-wrapper">
          <div class="spinner"></div>
        </div>
        <p class="loading-text">Chargement de l'article...</p>
      </div>
    </div>
  </div>

  <!-- 🔥 NOUVEAU : Gestion des erreurs -->
  <div *ngIf="hasError && !isLoading" class="error-container">
    <div class="container">
      <div class="error-content text-center">
        <i class="ri-error-warning-line error-icon"></i>
        <h2 class="error-title">Oops ! Une erreur s'est produite</h2>
        <p class="error-message">{{ errorMessage }}</p>
        <button class="btn btn-primary mt-3" routerLink="/news">
          ← Retour aux actualités
        </button>
      </div>
    </div>
  </div>

  <!-- 🔥 MODIFIÉ : Contenu principal affiché seulement quand chargé -->
  <div class="container" *ngIf="current_post && !isLoading && !hasError">
    <!-- En-tête stylisée -->
    <div class="article-header mb-4">
      <a class="back-link d-inline-block mb-2 text-decoration-none" routerLink="/news">
        ← <span class="hover-animate">AfroTech News</span>
      </a>
      <h1 class="article-title">{{ current_post.attributes.title }}</h1>
      <div class="article-meta d-flex align-items-center gap-3 mt-3">
        <span class="author d-flex align-items-center gap-1">
          ✍🏽 {{ current_post.attributes.publisher ? current_post.attributes.publisher: "tod01" }}
        </span>
        <span class="separator">|</span>
        <span class="date">
          📅 {{ current_post.attributes.publishedAt | date:'d MMMM y' }}
        </span>
      </div>
    </div>

    <!-- Image principale -->
    <img [src]="current_post.attributes.image.data.attributes.url" 
         alt="Image article" 
         class="featured-img mb-5" />

    <!-- Contenu principal -->
    <div class="article-content mb-5"
         markdown
         ngPreserveWhitespaces>
      {{ current_post.attributes.blogDetails }}
    </div>

    <!-- Tags -->
    <div class="article-tags border-top pt-4 mt-5 d-flex flex-wrap gap-3" 
         *ngIf="current_post.attributes.post_tags">
      <a *ngFor="let tag of getTags()"
         class="tag"
         [routerLink]="['/news']"
         [queryParams]="{ tag: normalizeTag(tag.attributes.tagName) }"
         title="Voir les articles liés au tag {{ tag.attributes.tagName }}">
        {{ tag.attributes.tagName }}
      </a>
    </div>

    <!-- Partage social -->
    <div class="share-section mt-4 d-flex align-items-center gap-3">
      <span class="share-label fw-semibold">Partager :</span>
      <a class="icon-link" [href]="shareLinks.facebook" target="_blank" title="Partager sur Facebook">
        <i class="ri-facebook-fill"></i>
      </a>
      <a class="icon-link" [href]="shareLinks.twitter" target="_blank" title="Partager sur Twitter">
        <i class="ri-twitter-fill"></i>
      </a>
      <a class="icon-link" [href]="shareLinks.linkedin" target="_blank" title="Partager sur LinkedIn">
        <i class="ri-linkedin-fill"></i>
      </a>
      <a class="icon-link" (click)="copyArticleLink()" title="Copier le lien de l'article">
        <i class="ri-share-fill"></i>
      </a>
      <span class="copied-msg text-success small" *ngIf="copied">Lien copié ! ✅</span>
    </div>

    <!-- Section Commentaires -->
    <!-- Composant des commentaires -->
    <div class="mt-5">
      <app-comments [articleId]="current_post.id" commentType="blog-posts"></app-comments>
    </div>

    <app-recommended-articles 
      [currentArticleId]="current_post.id" 
      [currentArticleTitle]="current_post?.attributes?.title">
    </app-recommended-articles>
  </div>
</div>

